import { createApp } from 'vue';
import "bootstrap/dist/css/bootstrap.css";
import BaseRow from "@/components/base/BaseRow";
import BaseColumn from "@/components/base/BaseColumn";
import BaseHeading from "@/components/base/BaseHeading";
import BaseParagraph from "@/components/base/BaseParagraph";
import ButtonPrimary from "@/components/buttons/ButtonPrimary";

import router from './router.js';
import App from './App.vue';

const app = createApp(App);
import store from './store'

app.use(router);
app.use(store);

app.component('BaseRow',BaseRow);
app.component('BaseColumn',BaseColumn);
app.component('BaseHeading',BaseHeading);
app.component('BaseParagraph',BaseParagraph);
app.component('ButtonPrimary',ButtonPrimary);

app.mount('#app');

import "bootstrap/dist/js/bootstrap.js";